import { pairLinks } from '../../../ui/tiles/pair-links';
import { LinkTileAdapter } from '../../../ui/tiles/LinkTileAdapter';
import { ImageTileAdapter } from '../../../ui/tiles/ImageTileAdapter';
import { sortByWeightAndAlphabetical } from '../utils/sort-by-weight-and-alphabetical';
import c from '../category-new.module.scss';

export const Subcategory = ({ subcategoryName, links, allCategories }) => {
  const sortedSubcategoryLinks = sortByWeightAndAlphabetical({
    list: links,
    weightKey: 'subcategoryWeight',
    alphabeticalKey: 'name',
  });

  const renderableLinks = pairLinks(sortedSubcategoryLinks);

  return (
    <div key={subcategoryName} className={c.contentSection}>
      <h3 className={c.subheading}>{subcategoryName}</h3>
      <div className={c.tilesContainer}>
        {renderableLinks.map((renderable, renderableIndex) => {
          if (renderable.renderType === 'single') {
            const { item } = renderable;
            return (
              <ImageTileAdapter
                entity={item}
                allCategories={allCategories}
                key={`${subcategoryName}-single-${renderableIndex}`}
              />
            );
          }

          const { items } = renderable;
          const isPair = items.length === 2;

          return (
            <div
              className={c.tilePair}
              key={`${subcategoryName}-pair-${renderableIndex}`}
            >
              {items.map((item, itemIndex) => (
                <LinkTileAdapter
                  entity={item}
                  allCategories={allCategories}
                  className={isPair ? c.grow : undefined}
                  key={`${subcategoryName}-link-${renderableIndex}-${itemIndex}`}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
